export default "__VITE_ASSET__nCutz$4O__"